import '@angular/localize/init';

// This is required for buffer.js to work properly
( window as any ).global = window;
